import { render } from "./MonetaryPolicy.vue?vue&type=template&id=c945a76e&scoped=true"
import script from "./MonetaryPolicy.vue?vue&type=script&lang=js"
export * from "./MonetaryPolicy.vue?vue&type=script&lang=js"

import "./MonetaryPolicy.vue?vue&type=style&index=0&id=c945a76e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c945a76e"]])

export default __exports__